import React from 'react';
import { Link, StatusIndicator } from '@amzn/awsui-components-react';
import { DisplayConnection, mapConnectionStatus } from './utils';

export const formatDirection = (d: DisplayConnection['direction']) =>
  d === 'inbound' ? 'Inbound' : 'Outbound';

export const formatConnectionMode = (mode: string): string => {
  const map: Record<string, string> = {
    DIRECT: 'Direct',
    VPC_ENDPOINT: 'VPC Endpoint',
  };
  return map[(mode || '').toUpperCase()] || mode || 'N/A';
};

export const columnDefinitions = [
  {
    id: 'connectionAlias',
    header: 'Connection Alias',
    cell: (item: DisplayConnection) => item.connectionAlias || 'N/A',
  },
  {
    id: 'remoteDomain',
    header: 'Remote Domain',
    cell: (item: DisplayConnection) =>
      item.tumblerLink ? (
        <Link href={item.tumblerLink} external>
          {item.remoteDomainName || 'N/A'}
        </Link>
      ) : (
        item.remoteDomainName || 'N/A'
      ),
  },
  {
    id: 'remoteRegion',
    header: 'Region',
    cell: (item: DisplayConnection) => item.remoteRegion || 'N/A',
  },
  {
    id: 'remoteAccount',
    header: 'Account',
    cell: (item: DisplayConnection) => item.remoteAccountId || 'N/A',
  },
  {
    id: 'status',
    header: 'Status',
    cell: (item: DisplayConnection) => {
      const status = mapConnectionStatus(item.status);
      return <StatusIndicator type={status.type}>{status.label}</StatusIndicator>;
    },
  },
  {
    id: 'direction',
    header: 'Direction',
    cell: (item: DisplayConnection) => formatDirection(item.direction),
  },
  {
    id: 'connectionMode',
    header: 'Connection Mode',
    cell: (item: DisplayConnection) => formatConnectionMode(item.connectionMode),
  },
];
